import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import Loader from "./Loader";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";
import { addDoc } from "firebase/firestore";


import { serverTimestamp } from "firebase/firestore";


export default function TeamsTG() {
  const [cloud, setCloud] = useState(global.getProfileData());
  const [username, setUsername] = useState("User");
  const [activeToken, setActiveToken] = useState("");
  const [refCount, setRefCount] = useState(3);
  const [refLoading, setRefLoading] = useState(false);
  const [friends, setFriends] = useState(0);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [parentCode, setParentCode] = useState("");
  const [error, setError] = useState("");
  const [confirming, setConfirming] = useState("");
  const getUserByRefCode = async () => {
    setConfirming(true);
    try {
      // Query to find the user with the given refCode
      const usersRef = collection(db, "telegram_users");
      const q = query(usersRef, where("refCode", "==", parentCode));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        // Get the first matching document (assuming refCode is unique)
        const userDoc = querySnapshot.docs[0];
        const userData = userDoc.data();
        if (userData.tgUserid == tgUserid) {
          setError("Invalid Code " + parentCode);
        } else {
          setError("");
          console.log("User Found", userData);
          updateParentUser();
          addRewardsToParent(userData.tgUserid);
        }
        return userData;
      } else {
        setConfirming(false);
        setError("Invalid Code " + parentCode);
        return null;
      }
    } catch (error) {
      setConfirming(false);
      setError("Unable to check at the moment, please try again later");
    }
  };





      async function logAndUpdateEMRS(tgUserid, emrsToAdd, eventType) {
        setConfirming(true);
        try {
          const tgUseridNum = Number(tgUserid);
      
          
          await addDoc(collection(db, "telegram_emrs_log"), {
            tgUserid: tgUseridNum,
            EMRS: emrsToAdd,
            type: eventType,
            timestamp: new Date() 
          });
      
          console.log(`Log added for tgUserid ${tgUseridNum} with ${emrsToAdd} EMRS.`);
      
    
          const logsQuery = query(collection(db, "telegram_emrs_log"), where("tgUserid", "==", tgUseridNum));
          const logsSnapshot = await getDocs(logsQuery);
      
          let totalEMRS = 0;
          logsSnapshot.forEach((doc) => {

            if(doc.data().EMRS && doc.data().EMRS != null && !isNaN(doc.data().EMRS)){
              totalEMRS += doc.data().EMRS; 
            }
    


          });
      
          console.log(`Total EMRS for tgUserid ${tgUseridNum}: ${totalEMRS}`);
      
          
          const usersQuery = query(collection(db, "telegram_users"), where("tgUserid", "==", tgUseridNum));
          const usersSnapshot = await getDocs(usersQuery);
      
          
          const updatePromises = usersSnapshot.docs.map((userDoc) => {
            return updateDoc(doc(db, "telegram_users", userDoc.id),  { totalEMRS: totalEMRS });
          });
      
          await Promise.all(updatePromises); 
      
          console.log(`Updated totalEMRS for all users with tgUserid ${tgUseridNum}`);
//              getTelegramUser(tgUserid);  
              setConfirming(false);
     
      
        } catch (error) {
          setConfirming(false);
          console.error("Error in logAndUpdateEMRS:", error);
        }
      }
    
  


  const updateParentUser = async () => {
    if (parentCode != "") {
      try {
        // Query to find the user with the given tgUserid
        const usersRef = collection(db, "telegram_users");
        const q = query(usersRef, where("tgUserid", "==", tgUserid));
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          // Get the first matching document (assuming tgUserid is unique)
          const userDoc = querySnapshot.docs[0];
          const userDocRef = doc(db, "telegram_users", userDoc.id);
          // Update the parentUser field
          await updateDoc(userDocRef, { parentUser: parentCode });
          console.log(
            `Updated parentUser for tgUserid ${tgUserid} to ${parentCode}`
          );
          getTelegramUser(tgUserid);
        } else {
          console.log("No user found with tgUserid =", tgUserid);
        }
      } catch (error) {
        console.error("Error updating parentUser:", error);
      }
    }
  };
  const addRewardsToParent = async (parentId) => {


    await logAndUpdateEMRS(parentId,1000,"REFASPARENT");
    addRewardsToSelf();

    /*
    try {
      const usersRef = collection(db, "telegram_users");
      const q = query(usersRef, where("tgUserid", "==", parentId));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const userDoc = querySnapshot.docs[0]; // Assuming tgUserid is unique
        const userRef = doc(db, "telegram_users", userDoc.id);
        const currentEmrs = userDoc.data().totalEMRS || 0; // Get existing value or default to 0
        const newTotalEmrs = currentEmrs + 1000;
        await updateDoc(userRef, { totalEMRS: newTotalEmrs });
        console.log(
          `Updated totalEmrs to ${newTotalEmrs} for parent with tgUserid = ${parentId}`
        );
        
      } else {
        console.log("No user found with tgUserid =", tgUserid);
        setConfirming(false);
      }
    } catch (error) {
      setConfirming(false);
      console.error("Error updating totalEmrs:", error);
    }
      */
  };
  const addRewardsToSelf = async () => {

    await logAndUpdateEMRS(tgUserid,1000,"REFASCHILD");
    setConfirming(false);

    // try {
    //   const usersRef = collection(db, "telegram_users");
    //   const q = query(usersRef, where("tgUserid", "==", tgUserid));
    //   const querySnapshot = await getDocs(q);
    //   if (!querySnapshot.empty) {
    //     const userDoc = querySnapshot.docs[0]; // Assuming tgUserid is unique
    //     const userRef = doc(db, "telegram_users", userDoc.id);
    //     const currentEmrs = userDoc.data().totalEMRS || 0; // Get existing value or default to 0
    //     const newTotalEmrs = currentEmrs + 1000;
    //     await updateDoc(userRef, { totalEMRS: newTotalEmrs });
    //     console.log(
    //       `Updated totalEmrs to ${newTotalEmrs} for child with tgUserid = ${tgUserid}`
    //     );
    //     setConfirming(false);
    //   } else {
    //     console.log("No user found with tgUserid =", tgUserid);
    //     setConfirming(false);
    //   }
    // } catch (error) {
    //   setConfirming(false);
    //   console.error("Error updating totalEmrs:", error);
    // }
  };
  const getUsersByParent = async (parentUser) => {
    try {
      // Query Firestore for documents with the matching parentUser
      const usersRef = collection(db, "telegram_users");
      const q = query(usersRef, where("parentUser", "==", parentUser));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        // Extract user data from each document
        const users = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log("Users with parentUser:", users);
        setMembers(users);
        setFriends(users.length);
        return users;
      } else {
        console.log("No users found with parentUser = " + parentUser);
        return [];
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      return [];
    }
  };
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(
        cloud.userData.firstName +
          " " +
          cloud.userData.lastName +
          " is inviting you to earn money on telegram using Emorya Telegram App. Use referral code " +
          tgUserid +
          " in the teams section."
      );
      alert("Invitation code copied!");
    } catch (error) {
      console.error("Failed to copy text:", error);
    }
  };
  const shareText = async () => {
    //    const shareLink = "https://t.me/share/url?url=" + encodeURIComponent("https://t.me/emorya_bot?start=start");
    //   window.Telegram.WebApp.openTelegramLink(shareLink);
    /*
    const shareData = {
      title: "Burn Calories and Make Money!",
      text:
        cloud.userData.firstName +
        " " +
        cloud.userData.lastName +
        " is inviting you to earn money on telegram using Emorya Telegram App. Use referral code " +
        tgUserid +
        " in the teams section.",
      url: "https://t.me/emorya_bot?start=start", // Optional: Include a URL
    };
    */
    try {
      const referralMessage = `
A🎉 Join me on Emorya and start earning rewards! 🎰
💸 1000 coins  just signing up! 
💎 +25% of your friends earnings  
Ready to get your rewards? Let’s play together now! 🚀
Go to https://t.me/emorya_bot?start=start and use referral code ${tgUserid} in the teams section.`;
      const telegramShareURL = `https://t.me/share/url?url=${encodeURIComponent(
        "https://t.me/emorya_bot?start=start"
      )}&text=${encodeURIComponent(referralMessage)}`;
      window.Telegram.WebApp.openTelegramLink(telegramShareURL);
      /*
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
      }
      */
    } catch (error) {
      console.error("Error sharing:", error);
    }
  };
  const db = getFirestore();
  async function getTelegramUser(tgUserid) {
    try {
      const q = query(
        collection(db, "telegram_users"),
        where("tgUserid", "==", tgUserid)
      );
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const userData = querySnapshot.docs[0].data();
        console.log("User Data:", userData);
        setCloud({ ...cloud, userData: userData });
        getUsersByParent(userData.refCode);
        setLoading(false);
        return userData;
      } else {
        console.log("No user found with tgUserid:", tgUserid);
        return null;
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      return null;
    }
  }
  const [tgUserid, setTgUserId] = useState(0);
  useEffect(() => {
    setTgUserId(parseInt(localStorage.getItem("TGUSERID")));
    getTelegramUser(parseInt(localStorage.getItem("TGUSERID")));
  }, []);
  return (
    <>
      <div className="section">
        <Loader loading={loading}></Loader>
        <div
          style={{
            padding: 20,
            textAlign: "left",
            width: "100%",
          }}
        >
          <div className="mainHeading">
            <i
              className="fa-solid fa-people-group"
              style={{
                fontSize: 16,
              }}
            ></i>
            &nbsp;&nbsp;Teams
          </div>
          <br />
          <div
            style={{
              textAlign: "center",
              marginTop: 0,
            }}
          >
            <div
              className="glowBox"
              style={{
                textAlign: "left",
                marginTop: 5,
                padding: 10,
                fontSize: 13,
                borderRadius: 5,
              }}
            >
              <div
                style={{
                  float: "right",
                  fontSize: 15,
                  fontWeight: "bold",
                  marginTop: 5,
                }}
              >
                Invite Code:&nbsp;
                <span
                  style={{
                    color: "#db5e9c",
                    fontWeight: "bold",
                  }}
                >
                  {cloud.userData.refCode}
                </span>
                &nbsp; &nbsp;
                <i
                  onClick={() => {
                    handleCopy();
                  }}
                  className="fa-regular fa-copy"
                ></i>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <i
                  onClick={() => {
                    shareText();
                  }}
                  className="fa-solid fa-arrow-up-right-from-square"
                ></i>
              </div>
              <div>
                <div
                  className="profileImageGreen"
                  style={{
                    backgroundImage:
                      cloud.userData.imageUrl &&
                      cloud.userData.imageUrl != "" &&
                      cloud.userData.imageUrl != null
                        ? `url(${cloud.userData.imageUrl})`
                        : "",
                    height: 27,
                    width: 27,
                    borderRadius: "100%",
                  }}
                ></div>
                <br />
              </div>
            </div>
            <br />
            <div className="hotHeading">
              <strong
                style={{
                  fontSize: 14,
                }}
              >
                {friends} Friend{friends == 1 ? "" : "s"}.
              </strong>
            </div>
            {members.map((item, index) => {
              return (
                <div
                  key={index}
                  className="glowBox"
                  style={{
                    borderRadius: 5,
                    marginTop: 2,
                  }}
                >
                  <div className="memberLine">
                    <div
                      className="profileImageGreen"
                      style={{
                        backgroundImage:
                          item.imageUrl &&
                          item.imageUrl != "" &&
                          item.imageUrl != null
                            ? `url(${item.imageUrl})`
                            : "",
                        height: 25,
                        width: 25,
                        borderRadius: "100%",
                      }}
                    ></div>
                    <div
                      style={{
                        marginLeft: 10,
                        fontSize: 12,
                        fontWeight: "bold",
                        textAlign: "left",
                      }}
                    >
                      {item.firstName.trim()} {item.lastName.trim()}
                    </div>
                  </div>
                </div>
              );
            })}
            <br />
            <br />
          </div>
        </div>
        <div
          style={{
            width: "100%",
            padding: 20,
          }}
        >
          {!cloud.userData.parentUser || cloud.userData.parentUser == "" ? (
            <>
              <div
                style={{
                  textAlign: "left",
                  padding: "10px 10px",
                  borderStyle: "dashed",
                  borderRadius: 5,
                  borderWidth: 2,
                  fontWeight: "bold",
                }}
              >
                Earn 1000 instant EMRS by entring the referral code of your
                friend.
                <br />
                <input
                  type="text"
                  className="input"
                  placeholder="Enter Code"
                  onChange={(e) => {
                    setError("");
                    setParentCode(parseInt(e.target.value));
                  }}
                  style={{
                    marginTop: 10,
                  }}
                />
                <br />
                <button
                  className="btn btn-sm btn-success gradColor"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                  }}
                  onClick={() => {
                    if (!confirming) {
                      getUserByRefCode();
                    }
                  }}
                >
                  {confirming ? "Confirming.." : "Claim 1000 EMRS"}
                </button>
                {error !== "" ? (
                  <>
                    <div
                      style={{
                        padding: "10px 0px",
                        color: "red",
                      }}
                    >
                      {error}
                    </div>
                  </>
                ) : null}
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  textAlign: "left",
                  padding: "10px 10px",
                  borderRadius: 3,
                  borderWidth: 2,
                  borderColor: "#fff",
                  borderStyle: "dashed",
                }}
              >
                Invite more friends and earn 1000 EMRS instantly when they use
                your code in their teams section.
                <br />
                <br />
                <div
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  <div
                    style={{
                      float: "right",
                    }}
                  >
                    <i
                      onClick={() => {
                        handleCopy();
                      }}
                      className="fa-regular fa-copy"
                    ></i>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <i
                      onClick={() => {
                        shareText();
                      }}
                      className="fa-solid fa-arrow-up-right-from-square"
                    ></i>
                  </div>
                  Invite Code:&nbsp;
                  <span
                    style={{
                      color: "#0BBFAB",
                    }}
                  >
                    {cloud.userData.refCode}
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="spacer"></div>
      </div>
    </>
  );
}
